import { notification } from 'antd';
import { FormattedMsg } from '@components/i18n/formattedMsg';
import { isArray } from 'util';

export interface IErrorMessage {
    code: number;
    message: string;
    description: string | any[];
}

interface FunderError {
    errorCode: string;
    errorMsg: string;
    params: any
}

const DescriptionBuilder = (descriptions) => {
    if (typeof descriptions === 'string')
        return [<FormattedMsg key={new Date().toString()} id={descriptions} />]

    if (descriptions && descriptions.errors && isArray(descriptions.errors) && descriptions.errors.length > 0) {
        return descriptions.errors.map((item: FunderError) => <div key={new Date().toString()}><FormattedMsg id={item.errorCode} /><br /></div>);
    }

    return [<FormattedMsg key={new Date().toString()} id='FUNDER_ERR_INVALID_PARAM' />];
}

function ErrorMessage(props: IErrorMessage) {
    return notification.error({
        message: (<h3><strong>{`${props.code || ''} - `} <FormattedMsg id={`${props.message || 'UNEXPECTED_ERROR'}`} /></strong></h3>),
        description: DescriptionBuilder(props.description),
        duration: 60,
        type: 'error'
    });
}

export default ErrorMessage;